import { giveawayModuleIds, } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const entryFailureModalModule = {
    [giveawayModuleIds.ENTRY_FAILURE_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
